import React, { useState } from 'react';

function FilterIcon() {
	const [isClicked, setIsClicked] = useState(false);
	
	const handleClick = () => {
		setIsClicked(!isClicked);
	};
	return (
		<div
			className={`cursor-pointer flex flex-col items-flex-start justify-center h-6 w-6 bg-transparent ${
				isClicked ? 'bg-blue-500' : ''
			}`}
			onClick={handleClick}
		>
      <span
	      className={`h-1 bg-gray-800 transition-all duration-300 ${
		      isClicked ? 'w-4/5 bg-blue-600' : 'w-full'
	      }`}
      ></span>
			<span
				className={`h-1 my-1 bg-gray-800 transition-all duration-300 ${
					isClicked ? 'w-full bg-blue-600' : 'w-4/5'
				}`}
			></span>
			<span
				className={`h-1 bg-gray-800 transition-all duration-300 ${
					isClicked ? 'w-3/5 bg-blue-600' : 'w-3/5'
				}`}
			></span>
		</div>
	);
}

export default FilterIcon;
